import { render, staticRenderFns } from "./pembayaran_berhasil.vue?vue&type=template&id=591ffbd0&"
import script from "./pembayaran_berhasil.vue?vue&type=script&lang=js&"
export * from "./pembayaran_berhasil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports